<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <span class="pageSteps card-styling">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>
        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Usuários</p>
      </span>
      <div id="divTable" style="margin-top: 32px">
        <section
          class="d-flex justify-content-between align-items-center w-100 flex-wrap"
        >
          <div
            style="
              background: #f0f2f8;
              border-radius: 8px;
              width: 310px;
              height: 42px;
              max-width: 310px;
            "
            class="d-flex align-items-center justify-content-between"
          >
            <InputSearch @onUpdate="(value) => userByName(value)" />

            <!-- <img
                :src="require(`@/assets/images/svg/iconLupa.svg`)"
                alt=""
                style="border-radius: 8px"
                class="img-postagem"
              /> -->
          </div>

          <button
            class="btn margin-btn-novo"
            @click="createUser"
            style="
              background: var(--blue-medium);
              border-radius: 8px;
              color: var(--white);
              font-weight: 500;
              font-size: 16px;
              height: 48px;
              width: 100%;
              max-width: 193px;
            "
          >
            Criar Novo
          </button>
        </section>
        <div class="table-responsive w-100">
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th>Nome</th>
                <th>E-mail</th>
                <th>Criado em</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>
                  {{ formatTime(item.createdAt) }}
                  {{ currentHour(item.createdAt) }}
                </td>
                <td>{{ item.isActive }}</td>

                <td>
                  <router-link
                    :to="{
                      name: 'EditUser',
                      params: { email: item.email },
                    }"
                  >
                    <img
                      :src="
                        require(`@/assets/images/svg/ícone-seta-direita-azul.svg`)
                      "
                      alt=""
                    />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalUsers"
            :offset="offset"
            @firstPage="pagination('clickFirstPage')"
            @previousPage="pagination('clickPreviousPage')"
            @nextPage="pagination('clickNextPage')"
            @lastPage="pagination('clickLastPage')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loading from "vue-loading-overlay";
import moment from "moment/moment";

export default {
  name: "Users",
  components: { InputSearch, Pagination, Loading },
  data() {
    return {
      items: [],
      totalUsers: 0,
      offset: 0,
      nameToSearch: "",
      isLoading: false,
    };
  },
  async created() {
    this.isLoading = true;

    await this.getUsersByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 5,
    }).then((response) => {
      this.totalUsers = response.data.count;
      this.items = response.data.data;
    });
    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getOffset"]),
  },
  methods: {
    ...mapActions(["getAllUsers", "getByUserName", "getUsersByPagination"]),
    ...mapMutations(["SET_OFFSET"]),

    createUser() {
      this.$router.push({
        name: "NewUser",
      });
    },
    userByName: function userByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(userByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },
    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 5,
      };

      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);

          this.getUsersByPagination(data).then((response) => {
            this.totalUsers = response.data.count;
            this.items = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getUsersByPagination(data).then((response) => {
            this.items = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getUsersByPagination(data).then((response) => {
            this.items = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getUsersByPagination(data).then((response) => {
            this.items = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
    currentHour(value) {
      return moment(value).locale("pt-br").subtract(3, "hour").format("LT");
    },

    formatTime(value) {
      let time = new Date(value);
      time.setHours(time.getHours() - 3);
      return moment(time).format("DD/MM/YYYY");
    },
  },
};
</script>
<style scoped>
#divTable {
  width: 100%;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 24px 16px 24px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  margin-bottom: 22px;
}

@media only screen and (max-width: 768px) {
  .session-one {
    flex-direction: column;
  }

  .img-responsivo {
    max-width: 70%;
  }

  .margin-btn-novo {
    margin-top: 5px;
    max-width: 100%;
    width: 100%;
  }
}

img.img-postagem {
  margin: 10px 12px;
}

.table {
  margin: 0;
}

.table td,
.table th {
  vertical-align: middle;
}

.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}

thead.thead {
  border-color: var(--blue-light);
}

tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
